import { render, staticRenderFns } from "./usuarios.vue?vue&type=template&id=2639c9db&scoped=true&"
import script from "./usuarios.vue?vue&type=script&lang=js&"
export * from "./usuarios.vue?vue&type=script&lang=js&"
import style0 from "./usuarios.vue?vue&type=style&index=0&id=2639c9db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2639c9db",
  null
  
)

export default component.exports